import React, { useEffect, useRef, useState } from "react";
import * as Styles from "../styles/EquipmentModelStepFilter";
import { useBnbSelector } from "../../../../redux/store";
import { useWindowDimensions } from "../../../../../../../common-deprecated/hooks";
import type { ModelGradeType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { getEquipmentFilterQuery } from "../../../../utils/navUtils";
import { getCarImageFromConfig } from "../../../../../../shared-logic/utils/typedUtils";

const ModelFilterSlider = (props: { grade: ModelGradeType }): JSX.Element => {
    const { grade } = props;
    // Used frames for CCIS image slider
    const imageframes = [9, 0, 26];

    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const modelId = useBnbSelector((state) => state.model.id);
    const { isSelected } = getEquipmentFilterQuery();
    const filterItems = useBnbSelector((state) => state.model.filterItems);

    // Set the viewport width of the slider to propagate to useSlider.
    const windowWidth = useWindowDimensions().width;

    const viewPortRef = useRef<HTMLDivElement>(null);
    const [viewportWidth, setViewportWidth] = useState<number>(0);
    const [sliderX, setSliderX] = useState<number>(0);
    const [activePage, setActivePage] = useState<number>(0);

    useEffect(() => {
        if (viewPortRef.current) {
            const newViewportWidth = viewPortRef.current.getBoundingClientRect().width;
            if (newViewportWidth !== viewportWidth) setViewportWidth(newViewportWidth);
        }
    }, [windowWidth]);

    const goToPage = (page: number): void => {
        setActivePage(page);
        if (page !== 0) {
            const newSliderX = 0 - viewportWidth * page;
            if (Math.abs(newSliderX) <= imageframes.length * viewportWidth) setSliderX(newSliderX);
            else setSliderX(0 - (imageframes.length * viewportWidth - viewportWidth));
        } else {
            setSliderX(0);
        }
    };

    return (
        <Styles.Slider>
            <Styles.SliderViewport ref={viewPortRef}>
                <Styles.Track
                    style={{
                        width: "300%",
                    }}
                    position="absolute"
                    left={sliderX}
                >
                    {imageframes.map((frame, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Styles.ImageWrapper key={`${frame}-${index}`}>
                            <Styles.Image
                                src={getCarImageFromConfig(
                                    commonSettings,
                                    "day-exterior",
                                    frame,
                                    modelId,
                                    grade.defaultCarId,
                                    {
                                        type: "png",
                                        width: 390,
                                        height: 260,
                                        // This is providing negative padding (top) in order to force the returned dimensions of the image to match the designs.
                                        // No current issues are known using this method, however I would advise to use this with caution.
                                        padding: "0,0,-20,30",
                                        scaleMode: 3,
                                        bgColour: "FFFFFF",
                                    },
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    false,
                                    null,
                                    false,
                                    isSelected ? filterItems : [],
                                )}
                            />
                        </Styles.ImageWrapper>
                    ))}
                </Styles.Track>
                <Styles.SliderBottom>
                    {imageframes.map((frame, index) => (
                        <Styles.SliderBar onClick={() => goToPage(index)} active={activePage === index} />
                    ))}
                </Styles.SliderBottom>
            </Styles.SliderViewport>
        </Styles.Slider>
    );
};

export default ModelFilterSlider;
